<script setup>
import config from '@/common/config'
import StreetView from '@/components/member/StreetView.vue'
import { reactive } from 'vue'
import { useRoute } from 'vue-router'
const route=useRoute(),meta=reactive({svkey:0,hlookat:0,vlookat:0})
function reloadSv({svid,fid,hlookat,vlookat,initmode,minimapzoom}){
  window.history.pushState(null, '', `${config.frontRoot}member/svcon/${svid}/${fid}/${hlookat}/${vlookat}/${initmode}`)
  meta.svid=svid
  meta.fid=fid
  meta.hlookat=hlookat
  meta.vlookat=vlookat
  meta.initmode=initmode
  meta.minimapzoom=minimapzoom
  meta.svkey++
}
if(route.params.svid)meta.svid=route.params.svid
if(route.params.fid)meta.fid=route.params.fid
if(route.params.hlookat)meta.hlookat=Number(route.params.hlookat)
if(route.params.vlookat)meta.vlookat=Number(route.params.vlookat)
if(route.params.vlookat)meta.vlookat=Number(route.params.vlookat)
if(route.params.initmode)meta.initmode=route.params.initmode
</script>
<template>
  <StreetView :key="meta.svkey" :svid="meta.svid" :fid="meta.fid" :initmode="meta.initmode" :hlookat="meta.hlookat" :vlookat="meta.vlookat" :reload="reloadSv"/>
</template>
